module.exports = function (app, mod, invite) {
  var game_tx = mod.returnGameTransaction(invite.game_id);
  var desc = invite.verbose_game_type;
  if (invite.players.length >= invite.players_needed) {
    desc = 'active game';
  }
  if (invite.time_finished) {
    desc = 'finished game';
  }
  var html = "\n  <div class=\"arcade-lounge arcade-lounge--invite\">\n  <div class=\"arcade-lounge-header\">\n\t  <div class=\"arcade-lounge-header-image\" style=\"background-image: url('".concat(invite.game_mod.respondTo('arcade-games').image, "')\">\n\t  </div>\n\t  <div class=\"arcade-lounge-header-title\">").concat(invite.game_name, "</div>\n\t  <div class=\"arcade-lounge-header-desc\">").concat(desc, "</div>\n  </div>\n  <div class=\"arcade-lounge-body\">\n\t  <div class=\"arcade-lounge-section hide-scrollbar\">\n\t    <div class=\"arcade-lounge-players\">\n\t");

  // render players who have joined
  for (var i = 0; i < invite.players.length; i++) {
    var _invite$winner;
    html += "\n\t\t  <div class=\"arcade-lounge-playerbox saito-table-row\" id=\"invite-user-".concat(invite.players[i], "\">\n\t\t    <div class=\"saito-identicon-box").concat((_invite$winner = invite.winner) !== null && _invite$winner !== void 0 && _invite$winner.includes(invite.players[i]) ? ' winner' : '', "\">\n          <img class=\"saito-identicon\" src=\"").concat(app.keychain.returnIdenticon(invite.players[i]), "\">\n        </div>\n\t\t    ").concat(app.browser.returnAddressHTML(invite.players[i]), "\n        <div class=\"online-status-indicator\"></div>\n\t\t  </div>\t\t\t\t\t  \t  \n\t\t\t");
  }

  // render players who are requested to join
  for (var _i = 0; _i < invite.desired_opponent_publickeys.length; _i++) {
    html += "\n      <div class=\"arcade-lounge-playerbox saito-table-row arcade-lounge-playerbox--requested\" id=\"invite-user-".concat(invite.desired_opponent_publickeys[_i], "\">\n\t      <div class=\"saito-identicon-box\">\n\t      \t<img class=\"saito-identicon\" src=\"").concat(app.keychain.returnIdenticon(invite.desired_opponent_publickeys[_i]), "\">\n\t      </div>\n \t      ").concat(app.browser.returnAddressHTML(invite.desired_opponent_publickeys[_i]), "\n        <div class=\"online-status-indicator\"></div>\n\t    </div>\n     ");
  }

  // render empty slots
  for (var _i2 = 0; _i2 < invite.empty_slots; _i2++) {
    html += "\n\t        <div class=\"arcade-lounge-playerbox saito-table-row\">  \n\t      \t\t\t<div class=\"saito-identicon-box empty-slot\"></div>\n\t    \t\t\t<div class=\"saito-address\">open player slot</div>\t\n\t  \t\t\t</div>\n\t\t    ";
  }
  html += "  \n\t      </div>\n\t    <div class=\"saito-table\">\n\t\t\t  <div class=\"saito-table-body\">\n\t";
  html += formatOptions(invite.game_mod.returnShortGameOptionsArray(invite.options));
  if (invite.time_finished) {
    var datetime = app.browser.formatDate(invite.time_finished);
    html += addTimeStamp('finished at', datetime);
  } else if (invite.time_created) {
    var _datetime = app.browser.formatDate(invite.time_created);
    html += addTimeStamp('created at', _datetime);
  }
  if ((invite === null || invite === void 0 ? void 0 : invite.step) >= 0) {
    html += "<div class=\"saito-table-row\">\n              <div class=\"arcade-lounge-key\">game moves</div>\n\t\t\t\t\t\t\t<div class=\"arcade-lounge-value\">".concat(invite.step, "</div>\n\t\t\t\t\t</div>");
    if (invite !== null && invite !== void 0 && invite.game_status) {
      html += "<div class=\"saito-table-row\">\n              <div class=\"arcade-lounge-key\">status</div>\n\t\t\t\t\t\t\t<div class=\"arcade-lounge-value\">".concat(invite.game_status, "</div>\n\t\t\t\t\t</div>");
    }
  }
  if (invite !== null && invite !== void 0 && invite.method) {
    html += "<div class=\"saito-table-row\">\n              <div class=\"arcade-lounge-key\">game ending</div>\n\t\t\t\t\t\t\t<div class=\"arcade-lounge-value\">".concat(invite.method, "</div>\n\t\t\t\t\t</div>");
  }
  html += "\n\t\t\t  </div>\n\t\t  </div>\n\t    </div>\n\t  </div>\n\t  <div class=\"arcade-lounge-chat\"></div>\n\t  <div class=\"arcade-lounge-controls\">";
  if (!invite.time_finished) {
    if (invite.players.length >= invite.players_needed) {
      if (invite.players.includes(mod.publicKey)) {
        html += "<div id=\"arcade-game-controls-continue-game\" class=\"fat saito-button-primary\">continue game</div>";
        if (invite.players.length > 1) {
          html += "<div id=\"arcade-game-controls-forfeit-game\" class=\"fat saito-button-secondary\">forfeit game</div>";
        } else {
          console.debug(invite);
        }
        html += "<div id=\"arcade-game-controls-close-game\" class=\"fat saito-button-secondary\">cancel game</div>";
      } else if (invite.empty_slots) {
        html += "<div id=\"arcade-game-controls-watch-game\" class=\"fat saito-button-primary\">join table</div>";
      } else if (invite.game_mod.enable_observer) {
        html += "<div id=\"arcade-game-controls-watch-game\" class=\"fat saito-button-primary\">watch game</div>";
        if (invite.game_mod.doesGameExistLocally(invite.game_id)) {
          html += "<div id=\"arcade-game-controls-clear-game\" class=\"fat saito-button-secondary\">clear</div>";
        }
      }
    } else {
      if (invite.players.includes(mod.publicKey)) {
        if (mod.publicKey === invite.originator) {
          html += "<div id=\"arcade-game-controls-invite-join\" class=\"fat saito-button-primary\"><i class=\"fa-solid fa-link\"></i>share</div>";
          html += "<div id=\"arcade-game-controls-cancel-join\" class=\"fat saito-button-secondary\">cancel invite</div>";
        } else {
          html += "<div id=\"arcade-game-controls-cancel-join\" class=\"fat saito-button-secondary\">leave invite</div>";
        }
      } else if (invite.empty_slots > 0) {
        html += "<div id=\"arcade-game-controls-join-game\" class=\"fat saito-button-primary\">join game</div>";
      } else if (invite.desired_opponent_publickeys.includes(mod.publicKey)) {
        html += "<div id=\"arcade-game-controls-join-game\" class=\"fat saito-button-primary\">join game</div>\n\t\t\t\t\t\t\t\t<div id=\"arcade-game-controls-cancel-join\" class=\"fat saito-button-secondary\">decline invite</div>";
      }
    }
  } else {
    if (invite.game_mod.doesGameExistLocally(invite.game_id)) {
      html += "<div id=\"arcade-game-controls-continue-game\" class=\"fat saito-button-primary\">view game</div>";
    } else if (invite.game_mod.enable_observer && (invite === null || invite === void 0 ? void 0 : invite.step) > 0) {
      html += "<div id=\"arcade-game-controls-review-game\" class=\"fat saito-button-primary\">review game</div>";
    }
  }
  html += "\n\t  </div>\n</div>\n  ";
  return html;
};
var formatOptions = function formatOptions(sgoa) {
  var html = '';
  for (var i in sgoa) {
    html += "<div class=\"saito-table-row\">\n                <div class=\"arcade-lounge-key\">".concat(i.replace(/_/g, ' '), "</div>");
    if (sgoa[i] !== null) {
      html += "<div class=\"arcade-lounge-value\">".concat(sgoa[i], "</div>");
    }
    html += '</div>';
  }
  return html;
};
var addTimeStamp = function addTimeStamp(label, datetime) {
  return "<div class=\"saito-table-row\">\n              <div class=\"arcade-lounge-key\">".concat(label, "</div>\n\t\t\t\t\t\t\t<div class=\"arcade-lounge-value\">").concat(datetime.hours, ":").concat(datetime.minutes, ", ").concat(datetime.day, " ").concat(datetime.month, "</div>\n\t\t\t\t\t</div>");
};